import React from 'react'
import styled from '@emotion/styled'
import { SvgLazy } from '@mobi/component-library/Common/Svg/SvgLazy'
import { AppRoutes } from '@core/AppRoutes'
import { useFeature } from '@core/Utils/hooks/useFeature'
import { FeatureItemAnalyticsData, trackFeatureItemClicked } from '../analytics'
import { Badge } from '@core/Areas/BetLoop/Components/Badge/Badge'
import { appHistory } from '@core/Utils/routing/history'
import { FeaturedEventsItemStyled } from '../Item.styles'
import { spacing } from '@mobi/component-library/Theme/Common'

export const BetLoopFeaturedItem: React.FC<{
  accountNumber: number | null
}> = ({ accountNumber }) => {
  const isBetLoopFeatureActive = useFeature('content-hub-follow-me')

  if (!isBetLoopFeatureActive) {
    return null
  }

  const betLoopRoute = AppRoutes.BetLoop

  const betLoopTileData: FeatureItemAnalyticsData = {
    featureItemTitle: 'Bet Loop Feature Tile',
    featureItemPosition: 0,
    accountNumber: accountNumber,
    internalTrackingCode: null,
    clickUrl: betLoopRoute,
    endDate: '',
  }

  const navigateToBetLoop: React.MouseEventHandler<HTMLAnchorElement> = e => {
    e.preventDefault()
    trackFeatureItemClicked(betLoopTileData)
    appHistory.push(betLoopRoute)
  }

  return (
    <FeaturedEventsItemStyled href='#' onClick={navigateToBetLoop}>
      <WrapperStyled>
        <Badge>NEW</Badge>
        <SvgLazy name='BetLoopHeaderLogo' color='white' width='100%' />
      </WrapperStyled>
    </FeaturedEventsItemStyled>
  )
}

// =======
// Styles
// =======

const WrapperStyled = styled.div({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  maxWidth: '7.5rem',
  paddingTop: spacing.smx1,
  paddingBottom: '0.2rem',

  '> span:first-of-type': { position: 'absolute', top: 0, right: 0 },
})
